import type { TicketingCategoriesPayload } from '../components/types';

export const TICKETING_CATEGORIES_MOCK: TicketingCategoriesPayload = {
	categoryBreakdown: {
		selectedView: 'total',
		selectedCategory: null,
		total: {
			categories: [
				{
					id: 1,
					name: 'System Issue',
					count: 438,
					percentage: 34.1,
					subCategories: [
						{ id: 101, name: 'Vision Pick (WES)', count: 226, percentage: 51.6 },
						{ id: 102, name: 'Navigator', count: 178, percentage: 40.6 },
						{ id: 103, name: 'Integrations', count: 34, percentage: 7.8 },
					],
				},
				{
					id: 2,
					name: 'Access Request',
					count: 287,
					percentage: 22.4,
					subCategories: [
						{ id: 201, name: 'New User', count: 142, percentage: 49.5 },
						{ id: 202, name: 'Role Change', count: 98, percentage: 34.1 },
						{ id: 203, name: 'Deactivation', count: 47, percentage: 16.4 },
					],
				},
				{
					id: 3,
					name: 'Reporting',
					count: 224,
					percentage: 17.4,
					subCategories: [
						{ id: 301, name: 'Fix', count: 96, percentage: 42.9 },
						{ id: 302, name: 'Enhancement', count: 74, percentage: 33.0 },
						{ id: 303, name: 'Dashboard', count: 54, percentage: 24.1 },
					],
				},
				{
					id: 4,
					name: 'Training',
					count: 152,
					percentage: 11.8,
					subCategories: [
						{ id: 401, name: 'How-To', count: 88, percentage: 57.9 },
						{ id: 402, name: 'Knowledge Transfer', count: 64, percentage: 42.1 },
					],
				},
				{
					id: 5,
					name: 'System Enhancement',
					count: 118,
					percentage: 9.2,
					subCategories: [
						{ id: 501, name: 'Navigator', count: 72, percentage: 61.0 },
						{ id: 502, name: 'Vision Pick', count: 46, percentage: 39.0 },
					],
				},
				{
					id: 6,
					name: 'Hardware',
					count: 65,
					percentage: 5.1,
					subCategories: [
						{ id: 601, name: 'Scanner', count: 38, percentage: 58.5 },
						{ id: 602, name: 'Printer', count: 27, percentage: 41.5 },
					],
				},
				{
					id: 7,
					name: 'Configuration Update',
					count: 13,
					percentage: 1.0,
					subCategories: [
						{ id: 701, name: 'EWM', count: 7, percentage: 53.8 },
						{ id: 702, name: 'Navigator', count: 6, percentage: 46.2 },
					],
				},
				{
					id: 8,
					name: 'Process Question',
					count: 18,
					percentage: 1.4,
					subCategories: [
						{ id: 801, name: 'General Process', count: 11, percentage: 61.1 },
						{ id: 802, name: 'Workflow', count: 7, percentage: 38.9 },
					],
				},
				{
					id: 9,
					name: 'Office Hours Request',
					count: 11,
					percentage: 0.9,
					subCategories: [
						{ id: 901, name: 'Scheduling', count: 7, percentage: 63.6 },
						{ id: 902, name: 'Support Session', count: 4, percentage: 36.4 },
					],
				},
				{
					id: 10,
					name: 'RMA',
					count: 11,
					percentage: 0.9,
					subCategories: [
						{ id: 1001, name: 'Return', count: 7, percentage: 63.6 },
						{ id: 1002, name: 'Replacement', count: 4, percentage: 36.4 },
					],
				},
				{
					id: 11,
					name: 'VP Equipment / Operator Movement',
					count: 11,
					percentage: 0.9,
					subCategories: [
						{ id: 1101, name: 'Equipment Transfer', count: 7, percentage: 63.6 },
						{ id: 1102, name: 'Operator Reassignment', count: 4, percentage: 36.4 },
					],
				},
			],
		},
		open: {
			categories: [
				{
					id: 1,
					name: 'System Issue',
					count: 92,
					percentage: 45.5,
					subCategories: [
						{ id: 101, name: 'Vision Pick (WES)', count: 48, percentage: 52.2 },
						{ id: 102, name: 'Navigator', count: 38, percentage: 41.3 },
						{ id: 103, name: 'Integrations', count: 6, percentage: 6.5 },
					],
				},
				{
					id: 2,
					name: 'Access Request',
					count: 37,
					percentage: 18.3,
					subCategories: [
						{ id: 201, name: 'New User', count: 19, percentage: 51.4 },
						{ id: 202, name: 'Role Change', count: 13, percentage: 35.1 },
						{ id: 203, name: 'Deactivation', count: 5, percentage: 13.5 },
					],
				},
				{
					id: 3,
					name: 'Reporting',
					count: 41,
					percentage: 20.3,
					subCategories: [{ id: 301, name: 'Fix', count: 18, percentage: 43.9 }],
				},
				{
					id: 4,
					name: 'Training',
					count: 12,
					percentage: 5.9,
					subCategories: [],
				},
				{
					id: 5,
					name: 'System Enhancement',
					count: 16,
					percentage: 7.9,
					subCategories: [],
				},
				{
					id: 6,
					name: 'Hardware',
					count: 4,
					percentage: 2.0,
					subCategories: [],
				},
			],
		},
	},
	topSubCategories: {
		selectedView: 'total',
		total: [
			{ name: 'Vision Pick (WES)', category: 'System Issue', count: 226, percentage: 17.6 },
			{ name: 'Navigator', category: 'System Issue', count: 178, percentage: 13.9 },
			{ name: 'New User', category: 'Access Request', count: 142, percentage: 11.1 },
			{ name: 'Role Change', category: 'Access Request', count: 98, percentage: 7.6 },
			{ name: 'Fix', category: 'Reporting', count: 96, percentage: 7.5 },
		],
		open: [
			{ name: 'Vision Pick (WES)', category: 'System Issue', count: 48, percentage: 23.8 },
			{ name: 'Navigator', category: 'System Issue', count: 38, percentage: 18.8 },
			{ name: 'New User', category: 'Access Request', count: 19, percentage: 9.4 },
			{ name: 'Fix', category: 'Reporting', count: 18, percentage: 8.9 },
			{ name: 'Role Change', category: 'Access Request', count: 13, percentage: 6.4 },
		],
	},
	categoryTrend: [
		{
			category: 'System Issue',
			weeks: [
				{ label: 'WK20', value: 36 },
				{ label: 'WK21', value: 38 },
				{ label: 'WK22', value: 41 },
				{ label: 'LCW', value: 44 },
			],
		},
		{
			category: 'Access Request',
			weeks: [
				{ label: 'WK20', value: 24 },
				{ label: 'WK21', value: 23 },
				{ label: 'WK22', value: 24 },
				{ label: 'LCW', value: 23 },
			],
		},
		{
			category: 'Reporting',
			weeks: [
				{ label: 'WK20', value: 19 },
				{ label: 'WK21', value: 17 },
				{ label: 'WK22', value: 16 },
				{ label: 'LCW', value: 14 },
			],
		},
		{
			category: 'Training',
			weeks: [
				{ label: 'WK20', value: 12 },
				{ label: 'WK21', value: 13 },
				{ label: 'WK22', value: 12 },
				{ label: 'LCW', value: 13 },
			],
		},
		{
			category: 'System Enhancement',
			weeks: [
				{ label: 'WK20', value: 8 },
				{ label: 'WK21', value: 10 },
				{ label: 'WK22', value: 11 },
				{ label: 'LCW', value: 13 },
			],
		},
		{
			category: 'Hardware',
			weeks: [
				{ label: 'WK20', value: 6 },
				{ label: 'WK21', value: 5 },
				{ label: 'WK22', value: 4 },
				{ label: 'LCW', value: 4 },
			],
		},
		{
			category: 'Configuration Update',
			weeks: [
				{ label: 'WK20', value: 3 },
				{ label: 'WK21', value: 4 },
				{ label: 'WK22', value: 3 },
				{ label: 'LCW', value: 3 },
			],
		},
		{
			category: 'Process Question',
			weeks: [
				{ label: 'WK20', value: 5 },
				{ label: 'WK21', value: 5 },
				{ label: 'WK22', value: 4 },
				{ label: 'LCW', value: 4 },
			],
		},
		{
			category: 'Office Hours Request',
			weeks: [
				{ label: 'WK20', value: 3 },
				{ label: 'WK21', value: 2 },
				{ label: 'WK22', value: 3 },
				{ label: 'LCW', value: 3 },
			],
		},
		{
			category: 'RMA',
			weeks: [
				{ label: 'WK20', value: 3 },
				{ label: 'WK21', value: 3 },
				{ label: 'WK22', value: 2 },
				{ label: 'LCW', value: 3 },
			],
		},
		{
			category: 'VP Equipment / Operator Movement',
			weeks: [
				{ label: 'WK20', value: 3 },
				{ label: 'WK21', value: 3 },
				{ label: 'WK22', value: 3 },
				{ label: 'LCW', value: 2 },
			],
		},
	],
};

